var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToSearch = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#069DDF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#069DDF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "st0",
    points: "0,0 24,0 24,24 0,24  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,22v-6c-0.7-0.1-1.4-0.2-2-0.5V22H9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,13.9c2.3-0.3,4-2.1,4-4.4C14,7,12,5,9.5,5S5,7,5,9.5c0,1.4,0.7,2.7,1.7,3.5H10V13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,14H7v1.5c0.6,0.3,1.3,0.4,2,0.5V14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10,13.9V13H6.7c0.8,0.6,1.7,1,2.8,1C9.7,14,9.8,14,10,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9,16v6H7v-6.5c-0.4-0.1-0.7-0.3-1-0.5v8h4v-7c-0.2,0-0.3,0-0.5,0C9.3,16,9.2,16,9,16z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,14h-0.8l-0.3-0.3c1-1.1,1.6-2.6,1.6-4.2C16,5.9,13.1,3,9.5,3S3,5.9,3,9.5c0,2.3,1.2,4.3,3,5.5v-2h0.7 C5.7,12.2,5,10.9,5,9.5C5,7,7,5,9.5,5S14,7,14,9.5c0,2.3-1.7,4.2-4,4.4v2c1.4-0.1,2.7-0.6,3.7-1.5l0.3,0.3v0.8l5,5l1.5-1.5L15.5,14 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "9,14 7,14 7,17 4,17 4,19 7,19 7,22 9,22 9,19 12,19 12,17 9,17  "
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_to_search.d9ca0d0a15f8ae609fd54efe9ddfc62d.svg";